/**
* @fileoverview This file is generated by the Angular template compiler.
* Do not edit.
* @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
* tslint:disable
*/
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var styles = [".mod.mod-stepper[_ngcontent-%COMP%] {\n  border: 1px solid #f4f4f4;\n  border-radius: 3px;\n  position: relative;\n  margin: 0;\n  padding: 0; }"];
export { styles as styles };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/shared/components/roaming-stepper/roaming-stepper.component.scss.shim.ngstyle.js
// module id = null
// module chunks = 